<template>
  <account-modal class="unset-recurring-fee-free-modal">
    <template slot="heading">
      <div>Unset account {{ account.accountId }}<template v-if="account.hasName">&nbsp;“{{ account.name }}”</template> from being recurring fee free?</div>
    </template>

    <template slot="content">
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="loading"
        @click="onUnsetButtonClick"
      >unset</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'UnsetRecurringFeeFreeModal',
    components: {
      AccountModal,
      ErrorAlert
    },
    data () {
      return {
        freeRecurringFeeUnsetApiRequest: new ApiRequest(AccountApi.unsetRecurringFeeFree)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.userId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.freeRecurringFeeUnsetApiRequest.loading
      },
      error () {
        return this.freeRecurringFeeUnsetApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onUnsetButtonClick () {
        this.freeRecurringFeeUnsetApiRequest
          .execute(this.account.accountId)
          .then(this.freeRecurringFeeUnsetSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      freeRecurringFeeUnsetSuccessHandler () {
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Account has been unset from being recurring fee free.' }
          })
        }, 100)
      }
    }
  }
</script>
